import React, { createContext, useState, useEffect, useContext } from 'react';

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [token, setToken] = useState(null);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const savedToken = localStorage.getItem('token');
        const savedUserStr = localStorage.getItem('user');

        if (savedToken && savedUserStr) {
          let savedUser = null;
          try {
            savedUser = JSON.parse(savedUserStr);
          } catch (e) {
            console.error('Invalid user data', e);
            localStorage.removeItem('user'); // Cleanup
          }

          if (savedUser && typeof savedUser === 'object') {
            console.log('🔐 Успешная авторизация');
            setToken(savedToken);
            setUser(savedUser);
            setIsAuthenticated(true);
          } else {
            console.log('❌ Неавторизован (очистка)');
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            setToken(null);
            setUser(null);
            setIsAuthenticated(false);
          }
        } else {
          setIsAuthenticated(false);
          setToken(null);
          setUser(null);
        }
      } catch (error) {
        console.error('Auth error', error);
        setIsAuthenticated(false);
        setToken(null);
        setUser(null);
      } finally {
        // 3. loading всегда становится false в конце
        setLoading(false);
      }
    };

    checkAuth();
  }, []);

  const login = (userData, authToken) => {
    localStorage.setItem('token', authToken);
    localStorage.setItem('user', JSON.stringify(userData));
    setToken(authToken);
    setUser(userData);
    setIsAuthenticated(true);
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setToken(null);
    setUser(null);
    setIsAuthenticated(false);
  };

  const value = {
    isAuthenticated,
    token,
    user,
    loading,
    login,
    logout
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};